import type { SearchScope } from "@/features/search/searchScope";
import { serializeSearchScope } from "@/features/search/searchScope";

export const MAX_SEARCH_QUERY_LENGTH = 100;

export interface SearchDestination {
  to: "/search";
  search: { q: string; scope?: "op" };
}

export type SearchNavigator = (destination: SearchDestination) => unknown;

export function buildSearchDestination(
  value: string,
  scope: SearchScope = "all",
): SearchDestination | null {
  const query = value.trim().slice(0, MAX_SEARCH_QUERY_LENGTH);
  if (!query) return null;

  const serializedScope = serializeSearchScope(scope);
  return {
    to: "/search",
    search: {
      q: query,
      ...(serializedScope ? { scope: serializedScope } : {}),
    },
  };
}

export function runFullPostSearch(
  value: string,
  navigate: SearchNavigator,
  scope: SearchScope = "all",
): boolean {
  const destination = buildSearchDestination(value, scope);
  if (!destination) return false;

  void navigate(destination);
  return true;
}
